import { QUERY_PARAM_PARENT_PRODUCT } from '@canvas/constants/query-params';
import { contentAPILocal } from '@canvas/frame-api-devloop/canvas-frame-api-local';
import { isLocalEAPDevMode } from '@canvas/frame-api-devloop/is-dev-mode';
import {
  type ContentWindowApi,
  type ContentAPI,
  type ContentAPIFactory,
} from '@canvas/frame-api-types';

import { getEmbedSearchParams } from '../canvas-embed-params';
import { CanvasContentAPI, isFrameAPI, isLocalEAPTestMode } from '../canvas-frame-api';

import { SmartLinkAPI, NativeAPI } from './host-window-api';

const inLocalEAPMode = isLocalEAPDevMode() || isLocalEAPTestMode();

export const getContentAPI = (): ContentAPI | undefined => {
  try {
    // eslint-disable-next-line no-restricted-syntax
    return getFrameApi().contentAPI;
  } catch (err) {
    console.error(err);
    return;
  }
};

export const getFrameApi = (): ContentWindowApi => {
  // Adding a fallback here to satisfy unit tests where jsdom hasn't been set up yet
  const href = globalThis.location?.href ?? 'ws://.';
  const url = new URL(href);

  const containerAri = url.searchParams.get('containerAri');
  const boardAri = url.searchParams.get('boardAri');

  const embedded = url.searchParams.get(QUERY_PARAM_PARENT_PRODUCT) === 'smartLink';

  const isSmartLink = embedded && Boolean(containerAri) && Boolean(boardAri);

  let contentAPIOverride: ContentAPIFactory | undefined = undefined;

  if (inLocalEAPMode) {
    contentAPIOverride = (rawContentApi) => {
      return new CanvasContentAPI(
        isFrameAPI(rawContentApi) ? rawContentApi : contentAPILocal
      );
    };
  }

  const frameApi = isSmartLink
    ? new SmartLinkAPI(contentAPIOverride)
    : new NativeAPI(contentAPIOverride);

  return frameApi;
};

export const canvasFrameAPI = getContentAPI();
export { type ContentAPI } from '@canvas/frame-api-types';

const embedSearchParams = getEmbedSearchParams();

export const isEmbeddedSmartLink = () => {
  const { parentProduct } = embedSearchParams;

  return parentProduct === 'smartLink';
};
